import * as THREE from "three";
import loadingManager from "./loader.js";

export default function materials(scene) {
    const textureLoader = new THREE.TextureLoader(loadingManager)

    function loadPBR(basePath, colorFile, normalFile, roughFile, uvChannel) {
        const color = textureLoader.load('.' + basePath + colorFile)
        const normal = textureLoader.load('.' + basePath + normalFile)
        const rough = textureLoader.load('.' + basePath + roughFile)
        color.colorSpace = THREE.SRGBColorSpace
        color.wrapS = color.wrapT = THREE.RepeatWrapping
        normal.wrapS = normal.wrapT = THREE.RepeatWrapping
        rough.wrapS = rough.wrapT = THREE.RepeatWrapping
        // Привязываем к нужному UV-каналу
        color.channel = uvChannel
        normal.channel = uvChannel
        rough.channel  = uvChannel
        return new THREE.MeshStandardMaterial({
            map: color,
            normalMap: normal,
            roughnessMap: rough,
            roughness: 1.0,
            metalness: 0.0,
        })
    }

    function loadFrameColor(file) {
        const tex = textureLoader.load('./image/textures/frame_color/' + file)
        tex.colorSpace = THREE.SRGBColorSpace
        tex.flipY = false
        return new THREE.MeshStandardMaterial({
            map: tex,
            roughness: 0.4,
            metalness: 0.05,
        })
    }

    // ── WOOD (uvChannel = 1..4 соответствуют развёрткам модели) ─────────────
    const woodDark = loadPBR(
        '/image/textures/wood/dark/',
        'Poliigon_WoodAccoyaBarnwoodDeltaBlack_9758_BaseColor.jpg',
        'Poliigon_WoodAccoyaBarnwoodDeltaBlack_9758_Normal.png',
        'Poliigon_WoodAccoyaBarnwoodDeltaBlack_9758_Roughness.png',
        3  // dark_wood → UV3
    )

    const woodGray = loadPBR(
        '/image/textures/wood/gray/',
        'Poliigon_CompositeDeckingMatte_9027_BaseColor.jpg',
        'Poliigon_CompositeDeckingMatte_9027_Normal.png',
        'Poliigon_CompositeDeckingMatte_9027_Roughness.png',
        2  // gray_wood → UV2
    )

    const woodLight = loadPBR(
        '/image/textures/wood/light/',
        'Poliigon_WoodCladdingInterior_10365_BaseColor.jpg',
        'Poliigon_WoodCladdingInterior_10365_Normal.png',
        'Poliigon_WoodCladdingInterior_10365_Roughness.png',
        1  // light_wood → UV1
    )

    const woodMid = loadPBR(
        '/image/textures/wood/mid/',
        'Poliigon_WoodCladding_10796_BaseColor.jpg',
        'Poliigon_WoodCladding_10796_Normal.png',
        'Poliigon_WoodCladding_10796_Roughness.png',
        0  // mid_wood → UV0
    )

    // ── FRAME COLOR ──────────────────────────────────────────────────────────
    const frame1 = loadFrameColor('yacht_frame_color1.jpg')
    const frame2 = loadFrameColor('yacht_frame_color2.jpg')
    const frame3 = loadFrameColor('yacht_frame_color3.jpg')
    const frame4 = loadFrameColor('yacht_frame_color4.jpg')
    const frame5 = loadFrameColor('yacht_frame_color5.jpg')
    const frame6 = loadFrameColor('yacht_frame_color6.jpg')
    const frame7 = loadFrameColor('yacht_frame_color7.jpg')
    const frame8 = loadFrameColor('yacht_frame_color8.jpg')
    const frame9 = loadFrameColor('yacht_frame_color9.jpg')

    // ── LEATHER (plain color materials) ─────────────────────────────────────
    function makeSolidMat(hex, roughness = 0.6, metalness = 0.0) {
        return new THREE.MeshStandardMaterial({ color: hex, roughness, metalness })
    }

    const leatherWhite  = makeSolidMat(0xf0ede5, 0.65)
    const leatherBeige  = makeSolidMat(0xc2a07a, 0.65)
    const leatherBlack  = makeSolidMat(0x1a1a1a, 0.55)
    const leatherBrown  = makeSolidMat(0x6b3322, 0.60)
    const leatherNavy   = makeSolidMat(0x1c2840, 0.60)

    // ── BOTTOM COLOR (plain color materials) ─────────────────────────────────
    const bottomWhite   = makeSolidMat(0xf2f0ec, 0.45, 0.05)
    const bottomBlack   = makeSolidMat(0x111111, 0.45, 0.05)
    const bottomNavy    = makeSolidMat(0x0d1e36, 0.45, 0.05)
    const bottomRed     = makeSolidMat(0x7a1515, 0.45, 0.05)

    // Прогрев материалов (чтобы не было лага при первом применении)
    const allMats = [
        woodDark, woodGray, woodLight, woodMid,
        frame1, frame2, frame3, frame4, frame5, frame6, frame7, frame8, frame9,
        leatherWhite, leatherBeige, leatherBlack, leatherBrown, leatherNavy,
        bottomWhite, bottomBlack, bottomNavy, bottomRed,
    ]
    const tempGeo = new THREE.PlaneGeometry(0.001, 0.001)
    allMats.forEach(mat => {
        const m = new THREE.Mesh(tempGeo, mat)
        m.visible = false
        scene.add(m)
    })

    return {
        wood:   { dark: woodDark, gray: woodGray, light: woodLight, mid: woodMid },
        frame:  { c1: frame1, c2: frame2, c3: frame3, c4: frame4, c5: frame5, c6: frame6, c7: frame7, c8: frame8, c9: frame9 },
        leather:{ white: leatherWhite, beige: leatherBeige, black: leatherBlack, brown: leatherBrown, navy: leatherNavy },
        bottom: { white: bottomWhite, black: bottomBlack, navy: bottomNavy, red: bottomRed },
    }
}
